import i18n from '@/lang/index'
import SettingTypes from '@/utils/setting-types'

export default {
  name: 'goods',
  label: {
    title: i18n.t('commodity_module'),
    icon: require('@/assets/icon-component-label_Goods.png'),
    limit: -1
  },
  sort: 5,
  data: {
    // 商品列表
    goodsList: []
  },
  settings: {
    goodsList: {
      type: SettingTypes.custom,
      component_name: 'GoodsSelector'
    }
  }
}
